import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Profile/Details/details.container"
    ).then((module) => ({
        default: module.ProfileDetailsContainer
    }))
);
